import { NPC } from './NPC.js';
import { distance2D } from '../utils/math.js';

export class EntityManager {
  constructor() {
    this.npcs = [];
  }

  addNPC(npc) {
    this.npcs.push(npc);
    return npc;
  }

  removeNPC(id) {
    const idx = this.npcs.findIndex(n => n.id === id);
    if (idx !== -1) {
      const npc = this.npcs[idx];
      this.npcs.splice(idx, 1);
      return npc;
    }
    return null;
  }

  getNPC(id) {
    return this.npcs.find(n => n.id === id) || null;
  }

  // Get nearest interactable NPC to player
  getNearestInteractable(playerX, playerZ) {
    let nearest = null;
    let nearestDist = Infinity;

    for (const npc of this.npcs) {
      if (!npc.visible || !npc.interactable) continue;
      const dist = distance2D(npc.position.x, npc.position.z, playerX, playerZ);
      if (dist < npc.interactRange && dist < nearestDist) {
        nearest = npc;
        nearestDist = dist;
      }
    }
    return nearest;
  }

  update(dt, flags, paused) {
    for (const npc of this.npcs) {
      // Check condition function
      if (npc.conditionFn) {
        // `_stageExited` — a cutscene walked this character out of the room.
        // It outranks the condition until the room is rebuilt; see
        // StageDirector's `exit` beat.
        const shouldShow = !npc._stageExited && npc.conditionFn(flags);
        if (shouldShow && !npc.visible) npc.show();
        if (!shouldShow && npc.visible) npc.hide();
      } else if (npc._stageExited && npc.visible) {
        npc.hide();
      }
      // Freeze/unfreeze NPCs based on pause state. A staged actor is skipped:
      // freeze() clears the walk flag, which would stop a StageDirector walk
      // cycle dead while the body kept sliding.
      if (!npc._stageDriven) {
        if (paused && !npc._frozen) npc.freeze();
        if (!paused && npc._frozen) npc.unfreeze();
      }

      if (npc.visible) {
        npc.update(dt);
      }
    }
  }

  // Add all NPC meshes to scene
  addToScene(scene) {
    for (const npc of this.npcs) {
      scene.add(npc.mesh);
    }
  }

  // Remove all NPC meshes from scene
  removeFromScene(scene) {
    for (const npc of this.npcs) {
      scene.remove(npc.mesh);
    }
  }

  clear() {
    this.npcs = [];
  }
}
